import { Grid, useTheme } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { BackdropCircularProgress } from "@websential/cosmic";
import { IAppState } from "../../store/reducers";
import { ReportsService } from "../../services/ReportsService";
import { TransactionDetailDataTable } from "./TransactionDetailDataTable";
import { setSelectedActivityLogActions } from "../../store/actions/activityLogActions";
import { setSelectedStickyNavBar } from "../../store/actions/stickyNavBarActions";
import { useQuery } from "@tanstack/react-query";

export interface IInvoiceTransactionDetail { }

const useTransactionDetails = (
  clientId: string,
  taxYear: number,
  refNo: string,
) =>
  useQuery({
    queryKey: ["Transaction-detail", clientId, taxYear, refNo],
    queryFn: (data) => {
      return ReportsService.getInvoiceTransactionDetail(clientId, taxYear, refNo);

    },
    refetchOnWindowFocus: false
  });

export const InvoiceTransactionDetail: React.FC<IInvoiceTransactionDetail> = () => {
  const theme = useTheme();
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const clientId = useSelector((state: IAppState) => state.client.id);
  const clientName = useSelector((state: IAppState) => state.client.clientName);
  const taxYear = useSelector((state: IAppState) => state.taxYear.year);
  const refNo = useSelector((state: IAppState) => state.invoice.refNo);




  const { isLoading: isLoadingTransactionDetailList, data } = useTransactionDetails(clientId, taxYear, refNo); //useQuery('accountants-list', AccountantService.getAccountantList, refetchOnWindowFocus: false);
  const transactionDetailData: any = data;


  useEffect(() => {
    dispatch(setSelectedActivityLogActions({
      entityId1: '',
      entityId2: '',
      entityId3: '',
      screenName: '',
      companyName: '',
      activityType: "",
      activityLogVisibility: false
    }));
    dispatch(setSelectedStickyNavBar({ isSticky: false }));
  }, [])

  return (
    <>
      {/* <BackdropCircularProgress
          open={
            isLoading
          }
          testId="T4 Slip List"
        /> */}
      <Grid size={{ xs: 12, sm: 8, md: 8, lg: 8, xl: 8 }} sx={{ marginTop: theme.spacing(3) }}>
        <TransactionDetailDataTable
          rows={transactionDetailData && transactionDetailData.items}
          last_rows={transactionDetailData && transactionDetailData.sumData}
          columns={transactionDetailData && transactionDetailData.headerColumns}
          showIndexColumn={true}
          showChecboxColumn={false}
          showSettingColumn={false}
          isLoading={isLoadingTransactionDetailList}
        />
      </Grid>
    </>
  );
};
